import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class ReportYield extends Component {
  render() {
    return (
      <div className="card p-0">
        {this.props.yieldReportEntries.length ?
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th className="w-5">Session</th>
                <th className="hidden-md-down w-40">Ingredients</th>
                <th className="hidden-md-down">Station</th>
                <th className="hidden-xs-down">Date</th>
                <th className="hidden-md-down">Total Yield</th>
                <th>Main Prod. Yield</th>
                <th className="hidden-xs-down">Tolerance</th>
                <th className="hidden-xs-down">Avg. Yield</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {this.props.yieldReportEntries.map((yr, idx) => {
                let avgYieldCellStyle = {
                  background: yr.main_product_yield <= yr.average_yield ? 'rgb(236, 255, 236)' : 'rgb(250, 220, 220)',
                  color: yr.main_product_yield <= yr.average_yield ? '#058505' : '#8f0202',
                  textAlign: 'center'
                },
                toleranceCellStyle = {
                  background: yr.main_product_yield <= yr.tolerance ? 'rgb(236, 255, 236)' : 'rgb(250, 220, 220)',
                  color: yr.main_product_yield <= yr.tolerance ? '#058505' : '#8f0202',
                  textAlign: 'center'
                }
                return (
                  <tr key={idx}>
                    <td>
                      <NavLink to={`/session/${yr.session}/`}>
                        {yr.session}
                      </NavLink>
                    </td>
                    <td className="hidden-md-down">{yr.ingredients}</td>
                    <td className="hidden-md-down">{yr.station}</td>
                    <td className="hidden-xs-down">{yr.session_date}</td>
                    <td className="hidden-md-down">{yr.total_yield} %</td>
                    <td>{yr.main_product_yield} %</td>
                    <td className="hidden-xs-down" style={toleranceCellStyle}>{yr.tolerance} %</td>
                    <td className="hidden-xs-down" style={avgYieldCellStyle}>{yr.average_yield} %</td>
                    <td>
                        <a className="btn-sm btn-info" onClick={()=>this.props.openFilterModal(idx)}>
                            <i className="fa fa-filter color-white"></i>
                        </a>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        :
          <div className="shipment-no-items mb-0">
            No results for given filters
          </div>
        }
      </div>
    )
  }
}
